import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, CssBaseline, Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import faqData from './faqData.json';

const FAQDoc = ({ data = faqData }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 80vh;
  `;

  const StyledCard = styled(Card)`
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin: 20px auto;
    max-width: 70%;
    padding: 40px;
  `;

  return (
    <PageWrapper>
      <Helmet>
        <title>FAQ - Frequently Asked Questions | InnoWave API Hub</title>
        <meta
          name="description"
          content="Find answers to common questions about API's services, features, and support in our comprehensive FAQ section."
        />
        <meta name="keywords" content="FAQ, InnoWave API Hub, frequently asked questions, services" />
        <link rel="canonical" href="https://www.innowave.solutions.com/faq" />
      </Helmet>
      <StyledCard>
        <CssBaseline />
          <Typography variant="h3" mb={2} pl={2}>
            {data.header}
          </Typography>
          {data.content.map((item, index) => (
            <Accordion key={index} expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h5">
                  {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                  <Typography variant="body1">
                    {item.description}
                  </Typography>
                  {item.subDescriptions && (
                    <Box component="ul" sx={{ pl: 2, mt: 1, display: "inline-block" }}>
                      {item.subDescriptions.map((desc, subIndex) => (
                        <Box component="li" key={subIndex} sx={{ mb: 1 }}>
                          {desc}
                        </Box>
                      ))}
                    </Box>
                  )}
                  {item.additionalInfo && (
                    <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
                      {item.additionalInfo}
                    </Typography>
                  )}
              </AccordionDetails>
            </Accordion>
          ))}
      </StyledCard>
    </PageWrapper>
  );
};

FAQDoc.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.string.isRequired,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        subDescriptions: PropTypes.arrayOf(PropTypes.string),
        additionalInfo: PropTypes.string,
      })
    ).isRequired,
  }),
};

export default FAQDoc;
